import React from "react"
import InsideTable from "../insideTable"

function TableBody({
  page,
  getTableBodyProps,
  expandedRow,
  headerGroups,
  prepareRow,
  toggleRowExpansion,
  columns,
  data,
  activeReportStatus,
  isMobile,
  supervisorFilter,
  dateMatch,
  onClick,
  toggleViewModal,
  MultileReports,
  handleVerify,
  MultileScreen,
  totalHoursLoader,
  handleApprove,
  handleReject,
}) {
  return (
    <>
      {totalHoursLoader ? <div id="cover-spin"></div> : null}
      <tbody {...getTableBodyProps()}>
        {(page.length > 0 &&
          page.map(row => {
            prepareRow(row)
            return (
              <React.Fragment key={row.getRowProps().key}>
                <tr
                  style={{
                    cursor: "pointer",
                    backgroundColor:
                      (expandedRow === row.id && "#FBE8D7") ||
                      (!onClick &&
                        expandedRow !== row.id &&
                        supervisorFilter?.id !== 3 &&
                        "#e8f4f8"),
                  }}
                  {...row.getRowProps()}
                  className={
                    expandedRow === row.id && "table-info bg-opacity-25"
                  }
                >
                  {row.cells.map(cell => {
                    return (
                      <td
                        key={cell.id}
                        {...cell.getCellProps()}
                        data-label={cell.column.Header}
                        style={{
                          ...(cell.column.style || {}),
                        }}
                        onClick={e => {
                          if (onClick) {
                            e.preventDefault()
                            if (!dateMatch && cell.column.Header !== "Action") {
                              toggleRowExpansion(row.id)
                            } else if (supervisorFilter?.id === 4) {
                              toggleRowExpansion(row.id)
                            }
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </td>
                    )
                  })}
                </tr>
                
                {expandedRow === row.id && (
                  <tr>
                    <td colSpan={columns?.length} style={{ padding: 0 }}>
                      <InsideTable
                        id={row.id}
                        data={
                        activeReportStatus.id === 5 || activeReportStatus.id === 6
                        ? (data.filter(el => el.userName === row.original.userName)[0]?.data || [])
                        : (data.filter(el => el.accountId === row.original.accountId)[0]?.data || [])
                        }
                        columns={columns}
                        activeReportStatus={activeReportStatus}
                        isMobile={isMobile}
                        supervisorFilter={supervisorFilter}
                        onClick={false}
                        dateMatch={dateMatch}
                        toggleViewModal={toggleViewModal}
                        MultileReports={MultileReports}
                        handleVerify={handleVerify}
                        MultileScreen={MultileScreen}
                        handleApprove={handleApprove}
                        handleReject={handleReject}
                      />
                    </td>
                  </tr>
                )}
              </React.Fragment>
            )
          })) || (
          <tr>
            <td
              colSpan={headerGroups[0]?.headers?.length}
              className="react-bs-table-no-data p-5 text-center"
            >
              Sorry, There are no data to display
            </td>
          </tr>
        )}
      </tbody>
    </>
  )
}

export default TableBody
